
webpack.register(
    'modules/table/table',
    function() {
        return import('modules/table/table');
    },
    true
);